var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#FF6DB2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0809 37.12H49.7369L48.1049 45.28H54.6329V49.36H47.2889L45.5609 58H41.3369L43.0649 49.36H35.6729L33.9449 58H29.7209L31.4489 49.36H24.9209V45.28H32.2649L33.8969 37.12H27.3689V33.04H34.7129L36.4409 24.4H40.6649L38.9369 33.04H46.3289L48.0569 24.4H52.2809L50.5529 33.04H57.0809V37.12ZM43.8809 45.28L45.5129 37.12H38.1209L36.4889 45.28H43.8809Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/Hashtag.32cc7df548e6ce9129517e3324a58aa7.svg";
export { ForwardRef as ReactComponent };